import { Ros } from "../../../foxglove-client";
import { ServiceCaller } from "../base";

export type FoxgloveServiceOptions = {
  ros: Ros;
};

/**
 * ServiceCaller backed by foxglove_bridge via the vendored roslibjs-foxglove client.
 *
 * No getServiceType/rosapi round-trip: the service type and request/response schemas
 * come from the bridge's `advertiseServices`. Requests are CDR-encoded by the vendored
 * client (the bridge rejects non-cdr service requests).
 *
 * `callSpotService` / `callCustomActionService` are intentionally left as the base
 * "not meant to be called" stubs — SPOT is legacy ROS 1 and not a Foxglove target.
 */
export class FoxgloveServiceCaller extends ServiceCaller {
  private ros: Ros;

  constructor(options: FoxgloveServiceOptions) {
    super();
    this.ros = options.ros;
  }

  callService = async <ReqType, ResType>(
    serviceName: string,
    data: ReqType,
    options?: { serviceType?: string; timeoutMs?: number }
  ): Promise<ResType> => {
    const impl = this.ros.rosImpl;
    if (!impl) {
      throw new Error(
        `Cannot call service "${serviceName}": Foxglove client is not connected`
      );
    }
    // serviceType is ignored: the vendored client resolves the schema from the
    // bridge's advertiseServices message.
    return impl.sendServiceRequest<ReqType, ResType>(serviceName, data, {
      timeoutMs: options?.timeoutMs,
    });
  };
}
